export default __webpack_public_path__ + "static/media/qr-code-nft.8cdb0a70.svg";